/* DigitalPower theme JS — no jQuery, no libraries. ~1KB gzipped. */
(function () {
  'use strict';

  /* Scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Floating dock — adapts to the section behind it (dark/light) */
  var dock = document.querySelector('.dp-dock');
  var themed = Array.prototype.slice.call(document.querySelectorAll('[data-dock-theme]'));
  function dockTheme() {
    if (!dock) return;
    var y = window.innerHeight - 56;
    var current = null;
    for (var i = 0; i < themed.length; i++) {
      var r = themed[i].getBoundingClientRect();
      if (r.top <= y && r.bottom >= y) { current = themed[i]; break; }
    }
    var isDark = current && current.getAttribute('data-dock-theme') === 'dark';
    dock.classList.toggle('dp-dock--light', !isDark);
  }
  var dockTick = false;
  function dockOnScroll() {
    if (dockTick) return;
    dockTick = true;
    requestAnimationFrame(function () { dockTick = false; dockTheme(); });
  }
  window.addEventListener('scroll', dockOnScroll, { passive: true });
  window.addEventListener('resize', dockOnScroll);
  dockTheme();
})();

/* ============================================================
   v0.2 — sliders, drag cursor, testimonials, modal
   ============================================================ */
(function () {
  'use strict';

  /* --- Drag-to-scroll for horizontal rows --- */
  var dragRows = document.querySelectorAll('[data-drag]');
  dragRows.forEach(function (row) {
    row.classList.add('dp-row-drag');
    var down = false, startX = 0, startLeft = 0, moved = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = row.scrollLeft;
      row.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      row.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      row.classList.remove('is-dragging');
    });
    /* prevent accidental link clicks after drag */
    row.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  });

  /* --- "Плъзни" cursor bubble --- */
  var labeled = document.querySelectorAll('[data-cursor-label]');
  if (labeled.length && matchMedia('(pointer: fine)').matches) {
    var bubble = document.createElement('div');
    bubble.className = 'dp-cursor';
    document.body.appendChild(bubble);
    labeled.forEach(function (el) {
      el.addEventListener('pointerenter', function () {
        bubble.textContent = el.getAttribute('data-cursor-label') || '';
        bubble.classList.add('is-on');
      });
      el.addEventListener('pointerleave', function () { bubble.classList.remove('is-on'); });
      el.addEventListener('pointermove', function (e) {
        bubble.style.left = e.clientX + 'px';
        bubble.style.top = e.clientY + 'px';
      });
    });
  }

  /* --- Mission slider progress bar --- */
  document.querySelectorAll('[data-mission-row]').forEach(function (row) {
    var section = row.closest('.dp-mission');
    var thumb = section && section.querySelector('.dp-progress__thumb');
    var track = section && section.querySelector('.dp-progress__track');
    if (!thumb || !track) return;
    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var p = max > 0 ? row.scrollLeft / max : 0;
      var travel = track.clientWidth - thumb.offsetWidth;
      thumb.style.transform = 'translateX(' + (p * travel) + 'px)';
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* --- Testimonials slider --- */
  document.querySelectorAll('[data-testi]').forEach(function (root) {
    var slides = root.querySelectorAll('.dp-testi__slide');
    var avatars = root.querySelectorAll('.dp-testi__ava');
    if (!slides.length) return;
    var index = 0;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      avatars.forEach(function (a, n) { a.classList.toggle('is-active', n === index); });
    }
    var prev = root.querySelector('[data-testi-prev]');
    var next = root.querySelector('[data-testi-next]');
    prev && prev.addEventListener('click', function () { go(index - 1); });
    next && next.addEventListener('click', function () { go(index + 1); });
    avatars.forEach(function (a) {
      a.addEventListener('click', function () { go(parseInt(a.getAttribute('data-testi-goto'), 10) || 0); });
    });
  });

  /* --- Inquiry modal --- */
  var modal = document.querySelector('[data-dp-modal]');
  if (modal) {
    function openModal() {
      modal.classList.add('is-open');
      document.body.classList.add('dp-modal-open');
      var first = modal.querySelector('.dp-input');
      if (first) setTimeout(function () { first.focus(); }, 320);
    }
    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('dp-modal-open');
    }
    window.dpOpenInquiry = function (text) {
      if (text) {
        var ta = modal.querySelector('textarea[name="contact[body]"]');
        if (ta && !ta.value) ta.value = text;
      }
      openModal();
    };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('a[href="#zapitvane"], a[href$="#zapitvane"], [data-dp-modal-open]');
      if (opener) { e.preventDefault(); openModal(); return; }
      if (e.target.closest('[data-dp-modal-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    /* auto-open after a form submission round-trip */
    if (modal.querySelector('[data-dp-modal-autopen]')) openModal();
  }
})();

/* ============================================================
   v0.3 — Instagram-style likes, share, slider dots
   ============================================================ */
(function () {
  'use strict';

  function fmt(n) { return Number(n).toLocaleString('bg-BG'); }

  /* Format static counters */
  document.querySelectorAll('[data-fmt]').forEach(function (el) {
    var n = parseInt(el.textContent.replace(/\D/g, ''), 10);
    if (!isNaN(n)) el.textContent = fmt(n);
  });

  /* --- Likes: base value from settings + persistent per-device toggle --- */
  function likeKey(id) { return 'dp-like-' + id; }
  function readLiked(id) {
    try { return localStorage.getItem(likeKey(id)) === '1'; } catch (e) { return false; }
  }
  function writeLiked(id, on) {
    try { on ? localStorage.setItem(likeKey(id), '1') : localStorage.removeItem(likeKey(id)); } catch (e) {}
  }
  function renderLike(btn) {
    var base = parseInt(btn.getAttribute('data-like-base'), 10) || 0;
    var id = btn.getAttribute('data-like-id');
    var on = readLiked(id);
    btn.classList.toggle('is-liked', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var count = btn.querySelector('[data-like-count]');
    if (count) count.textContent = fmt(base + (on ? 1 : 0));
  }
  function toggleLike(btn, forceOn) {
    var id = btn.getAttribute('data-like-id');
    var on = readLiked(id);
    if (forceOn && on) { pop(btn); return; }
    writeLiked(id, forceOn ? true : !on);
    renderLike(btn);
    pop(btn);
  }
  function pop(btn) {
    btn.classList.remove('is-pop');
    void btn.offsetWidth; /* restart animation */
    btn.classList.add('is-pop');
  }
  document.querySelectorAll('[data-like]').forEach(function (btn) {
    renderLike(btn);
    btn.addEventListener('click', function () { toggleLike(btn, false); });
  });

  /* Double-tap / double-click on media = like with heart burst */
  document.querySelectorAll('[data-like-media]').forEach(function (media) {
    var card = media.closest('.dp-pcard');
    var btn = card && card.querySelector('[data-like]');
    var burst = media.querySelector('.dp-pcard__burst');
    var lastTap = 0;
    function doBurst() {
      if (btn) toggleLike(btn, true);
      if (burst) {
        burst.classList.remove('is-burst');
        void burst.offsetWidth;
        burst.classList.add('is-burst');
      }
    }
    media.addEventListener('dblclick', doBurst);
    media.addEventListener('touchend', function () {
      var now = Date.now();
      if (now - lastTap < 320) doBurst();
      lastTap = now;
    });
  });

  /* --- Share: Web Share API with clipboard fallback --- */
  document.querySelectorAll('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var raw = btn.getAttribute('data-share-url');
      var url = raw ? new URL(raw, location.origin).href : location.href;
      var title = btn.getAttribute('data-share-title') || document.title;
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('dp-act--copied');
          setTimeout(function () { btn.classList.remove('dp-act--copied'); }, 1800);
        });
      }
    });
  });

  /* --- Slider dots (synced with scroll, clickable) --- */
  document.querySelectorAll('[data-slider]').forEach(function (row) {
    var section = row.closest('section');
    var dotsWrap = section && section.querySelector('[data-dots]');
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('[data-dot]');
    var cards = row.querySelectorAll(':scope > *');
    if (!dots.length || !cards.length) return;
    var ticking = false;

    function activeIndex() {
      var center = row.scrollLeft + row.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) {
        var mid = c.offsetLeft + c.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function update() {
      ticking = false;
      var idx = activeIndex();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    row.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cards[i];
        row.scrollTo({ left: c.offsetLeft - (row.clientWidth - c.offsetWidth) / 2, behavior: 'smooth' });
      });
    });
    update();
  });
})();

/* ============================================================
   v0.4 — 3D tilt cards, gravity pills physics (lazy Matter.js)
   ============================================================ */
(function () {
  'use strict';

  /* --- Why cards: pointer tilt + depth parallax --- */
  if (matchMedia('(pointer: fine)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-tilt-zone]').forEach(function (zone) {
      var cards = zone.querySelectorAll('[data-tilt]');
      var raf = null, ev = null;
      function apply() {
        raf = null;
        cards.forEach(function (c) {
          var r = c.getBoundingClientRect();
          var dx = (ev.clientX - (r.left + r.width / 2)) / r.width;
          var dy = (ev.clientY - (r.top + r.height / 2)) / r.height;
          var f = Math.max(0, 1 - Math.hypot(dx, dy) / 2.4);
          c.style.transform =
            'perspective(720px) rotateY(' + (dx * 9 * f).toFixed(2) + 'deg)' +
            ' rotateX(' + (-dy * 9 * f).toFixed(2) + 'deg)' +
            ' translateZ(' + (f * 12).toFixed(1) + 'px)';
        });
      }
      zone.addEventListener('pointermove', function (e) {
        ev = e;
        if (!raf) raf = requestAnimationFrame(apply);
      });
      zone.addEventListener('pointerleave', function () {
        cards.forEach(function (c) { c.style.transform = ''; });
      });
    });
  }

  /* --- Gravity pills: falling + free dragging (Matter.js, lazy) --- */
  document.querySelectorAll('[data-gravity]').forEach(function (zone) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var src = zone.getAttribute('data-matter-src');
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { io.disconnect(); load(); }
    }, { rootMargin: '300px' });
    io.observe(zone);

    function load() {
      if (window.Matter) return init();
      var s = document.createElement('script');
      s.src = src;
      s.onload = init;
      document.head.appendChild(s);
    }

    function init() {
      var M = window.Matter;
      var stage = zone.querySelector('.dp-gravity__stage');
      var pills = Array.prototype.slice.call(zone.querySelectorAll('.dp-gpill'));
      if (!stage || !pills.length) return;

      /* measure while still in static flex layout, then switch to absolute */
      var sizes = pills.map(function (el) {
        return { w: el.offsetWidth, h: el.offsetHeight };
      });
      pills.forEach(function (el, i) {
        el.style.width = sizes[i].w + 'px';
        el.style.height = sizes[i].h + 'px';
      });
      zone.classList.add('is-live');

      var W = stage.clientWidth, H = stage.clientHeight;
      var engine = M.Engine.create({ enableSleeping: true });
      engine.gravity.y = 1.1;

      var walls = [
        M.Bodies.rectangle(W / 2, H + 40, W + 600, 80, { isStatic: true }),
        M.Bodies.rectangle(-40, H / 2 - H, 80, H * 4, { isStatic: true }),
        M.Bodies.rectangle(W + 40, H / 2 - H, 80, H * 4, { isStatic: true }),
        M.Bodies.rectangle(W / 2, -H * 2.5, W + 600, 80, { isStatic: true })
      ];
      M.Composite.add(engine.world, walls);

      var bodies = pills.map(function (el, i) {
        var s = sizes[i];
        var x = s.w / 2 + 20 + Math.random() * Math.max(40, W - s.w - 40);
        var y = -s.h - Math.random() * H * 0.8 - i * 46;
        var b = M.Bodies.rectangle(x, y, s.w, s.h, {
          chamfer: { radius: s.h / 2 - 1 },
          restitution: 0.32,
          friction: 0.35,
          frictionAir: 0.014,
          angle: (Math.random() - 0.5) * 0.6
        });
        b.el = el;
        return b;
      });
      M.Composite.add(engine.world, bodies);

      /* free dragging */
      var mouse = M.Mouse.create(stage);
      var mc = M.MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: { stiffness: 0.22, damping: 0.12 }
      });
      /* don't hijack page scroll */
      mouse.element.removeEventListener('wheel', mouse.mousewheel);
      mouse.element.removeEventListener('DOMMouseScroll', mouse.mousewheel);
      mouse.element.removeEventListener('touchstart', mouse.mousedown);
      mouse.element.removeEventListener('touchmove', mouse.mousemove);
      mouse.element.removeEventListener('touchend', mouse.mouseup);
      M.Composite.add(engine.world, mc);

      /* touch dragging: grab only when the finger lands on a pill */
      var touchC = null;
      function stagePoint(t) {
        var r = stage.getBoundingClientRect();
        return { x: t.clientX - r.left, y: t.clientY - r.top };
      }
      stage.addEventListener('touchstart', function (e) {
        var p = stagePoint(e.touches[0]);
        var hits = M.Query.point(bodies, p);
        if (!hits.length) return; /* not on a pill: let the page scroll */
        e.preventDefault();
        var b = hits[0];
        touchC = M.Constraint.create({
          pointA: p,
          bodyB: b,
          pointB: { x: p.x - b.position.x, y: p.y - b.position.y },
          stiffness: 0.22,
          damping: 0.12
        });
        M.Composite.add(engine.world, touchC);
      }, { passive: false });
      stage.addEventListener('touchmove', function (e) {
        if (!touchC) return;
        e.preventDefault();
        touchC.pointA = stagePoint(e.touches[0]);
      }, { passive: false });
      ['touchend', 'touchcancel'].forEach(function (ev) {
        stage.addEventListener(ev, function () {
          if (touchC) { M.Composite.remove(engine.world, touchC); touchC = null; }
        });
      });

      /* run only while visible */
      var running = false, last = 0;
      function tick(now) {
        if (!running) return;
        var dt = last ? Math.min(now - last, 33) : 16.7;
        last = now;
        M.Engine.update(engine, dt);
        for (var i = 0; i < bodies.length; i++) {
          var b = bodies[i];
          b.el.style.transform =
            'translate(' + (b.position.x - sizes[i].w / 2).toFixed(1) + 'px,' +
            (b.position.y - sizes[i].h / 2).toFixed(1) + 'px)' +
            ' rotate(' + b.angle.toFixed(3) + 'rad)';
        }
        requestAnimationFrame(tick);
      }
      var vis = new IntersectionObserver(function (entries) {
        var on = entries[0].isIntersecting;
        if (on && !running) { running = true; last = 0; requestAnimationFrame(tick); }
        else if (!on) running = false;
      });
      vis.observe(zone);
      running = true;
      requestAnimationFrame(tick);
    }
  });
})();

/* ============================================================
   Particles network background (custom, ~2.5KB, no library)
   Mirrors the classic particles.js config: 80/800^2 density,
   linked lines 150px @ .4, hover repulse 200, click push +4.
   ============================================================ */
(function () {
  'use strict';
  var canvases = document.querySelectorAll('[data-particles]');
  if (!canvases.length) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  canvases.forEach(function (canvas) {
    var section = canvas.parentElement;
    var ctx = canvas.getContext('2d');
    var color = canvas.getAttribute('data-color') || '#000000';
    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var CFG = {
      base: 80, area: 800 * 800, maxN: 130, minN: 24,
      size: 3, dist: 150, lineOp: 0.4, dotOp: 0.5,
      speed: 0.6, repulse: 200, push: 4
    };
    var W = 0, H = 0, parts = [], running = false, raf = null;
    var mouse = { x: -9999, y: -9999 };

    function mk(x, y) {
      var a = Math.random() * Math.PI * 2;
      var v = (0.3 + Math.random() * 0.7) * CFG.speed;
      return { x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, r: 0.6 + Math.random() * CFG.size };
    }
    function resize() {
      var r = section.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = W * DPR; canvas.height = H * DPR;
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      var n = Math.max(CFG.minN, Math.min(CFG.maxN, Math.round(CFG.base * (W * H) / CFG.area)));
      while (parts.length < n) parts.push(mk(Math.random() * W, Math.random() * H));
      parts.length = n;
    }
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      var i, j, p, dx, dy, d;
      for (i = 0; i < parts.length; i++) {
        p = parts[i];
        dx = p.x - mouse.x; dy = p.y - mouse.y; d = Math.hypot(dx, dy);
        if (d < CFG.repulse && d > 0.001) {
          var f = (CFG.repulse - d) / CFG.repulse;
          p.x += dx / d * f * 3; p.y += dy / d * f * 3;
        }
        p.x += p.vx; p.y += p.vy;
        if (p.x < -12) p.x = W + 12; if (p.x > W + 12) p.x = -12;
        if (p.y < -12) p.y = H + 12; if (p.y > H + 12) p.y = -12;
      }
      ctx.lineWidth = 1;
      ctx.strokeStyle = color;
      for (i = 0; i < parts.length; i++) {
        for (j = i + 1; j < parts.length; j++) {
          dx = parts[i].x - parts[j].x; if (dx > CFG.dist || dx < -CFG.dist) continue;
          dy = parts[i].y - parts[j].y; if (dy > CFG.dist || dy < -CFG.dist) continue;
          d = Math.hypot(dx, dy);
          if (d < CFG.dist) {
            ctx.globalAlpha = CFG.lineOp * (1 - d / CFG.dist);
            ctx.beginPath(); ctx.moveTo(parts[i].x, parts[i].y); ctx.lineTo(parts[j].x, parts[j].y); ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = CFG.dotOp; ctx.fillStyle = color;
      for (i = 0; i < parts.length; i++) {
        p = parts[i];
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832); ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(tick);
    }

    window.addEventListener('pointermove', function (e) {
      var r = canvas.getBoundingClientRect();
      mouse.x = e.clientX - r.left; mouse.y = e.clientY - r.top;
    }, { passive: true });
    window.addEventListener('click', function (e) {
      var r = canvas.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (x >= 0 && y >= 0 && x <= W && y <= H) {
        for (var k = 0; k < CFG.push; k++) parts.push(mk(x, y));
      }
    });
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(section);
    else window.addEventListener('resize', resize);
    var io = new IntersectionObserver(function (es) {
      var on = es[0].isIntersecting;
      if (on && !running) { running = true; raf = requestAnimationFrame(tick); }
      else if (!on) { running = false; cancelAnimationFrame(raf); }
    });
    io.observe(section);
    resize();
  });
})();

/* ============================================================
   "Попитай ни" — AI-style inquiry funnel
   Typewriter placeholder + chips + input -> prefilled modal
   ============================================================ */
(function () {
  'use strict';
  var zones = document.querySelectorAll('[data-ask-zone]');
  if (!zones.length) return;

  zones.forEach(function (zone) {
    var input = zone.querySelector('[data-ask-input]');
    var send = zone.querySelector('[data-ask-send]');
    var chips = zone.querySelectorAll('[data-ask-chip]');
    var phrases = Array.prototype.map.call(chips, function (c) {
      return c.getAttribute('data-ask-chip');
    }).filter(Boolean);

    function open(text) {
      if (typeof window.dpOpenInquiry === 'function') window.dpOpenInquiry(text);
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { open(c.getAttribute('data-ask-chip')); });
    });
    if (send) send.addEventListener('click', function () { open(input && input.value.trim()); });
    if (input) input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); open(input.value.trim()); }
    });

    /* typewriter placeholder */
    if (!input || !phrases.length) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pi = 0, ci = 0, deleting = false, visible = false, timer = null;
    function step() {
      if (!visible) return;
      if (document.activeElement === input || input.value) {
        timer = setTimeout(step, 900); return;
      }
      var phrase = phrases[pi];
      if (!deleting) {
        ci++;
        input.placeholder = phrase.slice(0, ci);
        if (ci === phrase.length) { deleting = true; timer = setTimeout(step, 1700); return; }
        timer = setTimeout(step, 45 + Math.random() * 40);
      } else {
        ci--;
        input.placeholder = phrase.slice(0, ci) || ' ';
        if (ci === 0) { deleting = false; pi = (pi + 1) % phrases.length; timer = setTimeout(step, 400); return; }
        timer = setTimeout(step, 22);
      }
    }
    var io = new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      clearTimeout(timer);
      if (visible) step();
    });
    io.observe(zone);
  });
})();

/* ============================================================
   "Сътворението" — scroll progress driver for the pinned scene
   ============================================================ */
(function () {
  'use strict';
  var scenes = document.querySelectorAll('[data-adam]');
  if (!scenes.length) return;
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    scenes.forEach(function (el) { el.style.setProperty('--p', 1); });
    return;
  }
  scenes.forEach(function (el) {
    var ticking = false;
    function update() {
      ticking = false;
      var rect = el.getBoundingClientRect();
      var total = el.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
      el.style.setProperty('--p', p.toFixed(4));
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();

/* ---------- v2.3.1: Stacked flow — краят на страницата се прелива като process панелите ---------- */
(function () {
  'use strict';
  var anchorEl = document.querySelector('.dp-testi') || document.querySelector('.dp-faq');
  var footerEl = document.querySelector('.dp-footer');
  if (!anchorEl || !footerEl) return;

  var main = document.getElementById('dp-main');
  var anchor = anchorEl.closest('.shopify-section') || anchorEl.parentElement;
  var footWrap = footerEl.closest('.shopify-section') || footerEl.parentElement;
  if (!anchor || !footWrap) return;

  /* Футърът е извън <main> в theme.liquid — вкарваме го в общия sticky
     контекст на веригата. В Theme Editor (designMode) не местим DOM. */
  if (main && !(window.Shopify && window.Shopify.designMode)) {
    if (!main.contains(footWrap)) main.appendChild(footWrap);
  }

  /* Веригата: testimonials + ВСИЧКИ секции след нея по DOM ред + футъра.
     Така всяка секция участва в стака и нищо не остава „затрупано". */
  var wraps = [anchor];
  var n = anchor.nextElementSibling;
  while (n) {
    if (n.classList && n.classList.contains('shopify-section') && n.offsetHeight > 40) {
      wraps.push(n);
    }
    n = n.nextElementSibling;
  }
  if (wraps.indexOf(footWrap) === -1) wraps.push(footWrap);
  if (wraps.length < 2) return;

  /* Секции извън каданса: скролват нормално, но остават над закачените
     преди тях, за да не бъдат затрупани, докато са в опашката. */
  var EXCLUDE = '.dp-adam';

  wraps = wraps.filter(function (w, i) {
    if (w.querySelector(EXCLUDE)) {
      w.style.position = 'relative';
      w.style.zIndex = 10 + i;
      return false;
    }
    return true;
  });
  if (wraps.length < 2) return;

  wraps.forEach(function (w, i) {
    w.classList.add('dp-stack', 'dp-stack--card');
    w.style.zIndex = 10 + i;
  });

  /* Секции, по-високи от viewport-а, се скролват докрай и чак тогава се
     закачат (дъното им опира дъното на екрана); по-ниските се закачат горе.
     После следващата карта ги покрива. */
  function measure() {
    var vh = window.innerHeight;
    wraps.forEach(function (w) {
      w.style.setProperty('--stick', Math.min(0, vh - w.offsetHeight) + 'px');
    });
  }
  measure();
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(measure);
    wraps.forEach(function (w) { ro.observe(w); });
  }
})();

/* ---------- v3.4: Showcase — transform слайдер + autoplay (desktop), swipe (mobile) ---------- */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 681px)');
  document.querySelectorAll('[data-scl]').forEach(function (wrap) {
    var sec = wrap.closest('.dp-showcase');
    var row = wrap.querySelector('.dp-showcase__row');
    if (!row || wrap.classList.contains('dp-scl--static')) return;
    var cards = row.querySelectorAll('.dp-scard');
    var count = cards.length;
    if (count < 2) return;
    var prev = sec.querySelector('[data-show-prev]');
    var next = sec.querySelector('[data-show-next]');
    var cur = sec.querySelector('[data-show-current]');
    var box = sec.querySelector('[data-show-progress]');
    var thumb = box && box.querySelector('.dp-progress__thumb');
    var track = box && box.querySelector('.dp-progress__track');
    var i = 0, timer = 0;
    var delay = (parseInt(wrap.getAttribute('data-autoplay'), 10) || 0) * 1000;

    function step() {
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function visible() {
      return Math.max(1, Math.floor(wrap.clientWidth / step()));
    }
    function maxI() { return Math.max(0, count - visible()); }
    function paint() {
      if (!mq.matches) { row.style.setProperty('--scl-x', '0px'); return; }
      var m = maxI();
      if (i > m) i = m;
      row.style.setProperty('--scl-x', (-i * step()) + 'px');
      if (cur) cur.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      if (thumb && track) {
        var travel = track.clientWidth - thumb.offsetWidth;
        thumb.style.transform = 'translateX(' + ((m > 0 ? i / m : 0) * travel) + 'px)';
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= m;
    }
    function go(n, user) {
      var m = maxI();
      i = n > m ? 0 : (n < 0 ? m : n);
      paint();
      if (user) restart();
    }
    function tick() { if (mq.matches) go(i + 1, false); }
    function restart() {
      if (timer) clearInterval(timer);
      if (delay > 0) timer = setInterval(tick, delay);
    }
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); });
    wrap.addEventListener('pointerenter', function () { if (timer) clearInterval(timer); });
    wrap.addEventListener('pointerleave', restart);
    window.addEventListener('resize', paint, { passive: true });
    window.addEventListener('load', paint);
    if (mq.addEventListener) mq.addEventListener('change', function () { i = 0; paint(); });
    paint();
    restart();
  });
})();

/* ---------- v3.4: Проекти — transform слайдер на десктоп ---------- */
(function () {
  'use strict';
  var mq = window.matchMedia('(min-width: 901px)');
  document.querySelectorAll('[data-pjsl]').forEach(function (wrap) {
    var row = wrap.querySelector('.dp-projects__row');
    if (!row) return;
    var cards = row.querySelectorAll('.dp-pcard');
    var count = cards.length;
    if (count < 2) return;
    var prev = wrap.querySelector('[data-pjsl-prev]');
    var next = wrap.querySelector('[data-pjsl-next]');
    var cur = wrap.querySelector('[data-pjsl-count]');
    var tot = wrap.querySelector('[data-pjsl-total]');
    var thumb = wrap.querySelector('.dp-progress__thumb');
    var track = wrap.querySelector('.dp-progress__track');
    var i = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function step() {
      var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function visible() { return Math.max(1, Math.floor(wrap.clientWidth / step())); }
    function maxI() { return Math.max(0, count - visible()); }
    function paint() {
      if (!mq.matches) { row.style.setProperty('--pjsl-x', '0px'); return; }
      var m = maxI();
      if (i > m) i = m;
      if (tot) tot.textContent = pad(m + 1);
      row.style.setProperty('--pjsl-x', (-i * step()) + 'px');
      if (cur) cur.textContent = pad(i + 1);
      if (thumb && track) {
        var travel = track.clientWidth - thumb.offsetWidth;
        thumb.style.transform = 'translateX(' + ((m > 0 ? i / m : 0) * travel) + 'px)';
      }
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= m;
    }
    if (prev) prev.addEventListener('click', function () { i = Math.max(0, i - 1); paint(); });
    if (next) next.addEventListener('click', function () { i = Math.min(maxI(), i + 1); paint(); });
    window.addEventListener('resize', paint, { passive: true });
    window.addEventListener('load', paint);
    if (mq.addEventListener) mq.addEventListener('change', function () { i = 0; paint(); });
    paint();
  });
})();

/* ---------- v3.5: Броячи (лендинг статистики) ---------- */
(function () {
  'use strict';
  var els = document.querySelectorAll('[data-count]');
  if (!els.length || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseInt(el.getAttribute('data-count'), 10) || 0;
      var t0 = null, dur = 1400;
      function frame(t) {
        if (!t0) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(eased * target);
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
})();
